import React from "react";
import './Referral.css';
import { directDeepLink, SOURCE_HOME, SOURCE_WEBVIEW } from "./util"

function Referral(){
    return (
      <div className="referral-main">
        <div className="referral-container">
            <div className="referral-sub-container">
                <div className="referral-header">
                        <div className="referral-left">
                            <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/leftimage.png" className="referral-caption"/>
                        </div>
                        <div className="referral-line"></div>
                        <div className="referral-right">
                            <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/rightimage.png" className="referral-rimage"/>
                        </div>
                </div>
                <div className="referral-body">
                  <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/1year.png" className="referral-first"/>
                  <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/2year.png" className="referral-second"/>
                  <button className="referral-btn" onClick={() => {
                  let DeepLink = {
                    screen: 'UTIL_BROWSER',
                    paramOne: `https://docs.google.com/forms/d/e/1FAIpQLSdtwyEUno2EXxf2NVsef_T5Yv1nyFcWlr81pBGRQbaYkkrXCA/viewform?vc=0&c=0&w=1&flr=0`,
                    paramTwo: '',
                    paramThree: '',
                    paramSource: '',
                  };
                  directDeepLink(DeepLink, SOURCE_HOME);
				}}>
                    <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/form.png" className="form-icon"/>
                      Fill form now
                  </button>
                </div>
                
            </div>
        </div>
      </div>
    )
}

export default Referral;
